// extracted by mini-css-extract-plugin
export default {"tabBar":"orders__tabBar__jXYoDk","tabBarBorder":"orders__tabBarBorder__sj6Vgb","tabButton":"orders__tabButton__u9TcuF","tabIndicator":"orders__tabIndicator__KgX84I"};